var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgProfile = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M32.255 34.86c0 8.735 7.149 15.826 15.915 15.826 8.767 0 15.897-7.108 15.915-15.825v-9.036C64.085 17.09 56.937 10 48.17 10c-8.784 0-15.915 7.09-15.915 15.825v9.036Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M36.938 36.484c0 7.257 5.745 13.148 12.79 13.148 7.045 0 12.775-5.906 12.79-13.148v-7.507c0-7.258-5.745-13.149-12.79-13.149-7.06 0-12.79 5.891-12.79 13.149v7.507Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M63.252 35.456c0 4.657-1.534 8.326-4.157 10.834-2.628 2.511-6.424 3.927-11.074 3.927-4.65 0-8.389-1.415-10.962-3.922-2.57-2.505-4.054-6.175-4.054-10.839 0-1.114-.053-2.854-.106-4.599l-.002-.08c-.054-1.782-.107-3.56-.107-4.721 0-9.839 8.17-15.23 15.23-15.23 7.062 0 15.232 5.391 15.232 15.23v9.401Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M20.563 79.352C26.555 82.499 36.908 86 48.022 86c11.113 0 21.782-3.501 27.775-6.648A6.513 6.513 0 0 0 79.3 73.94c.498-8.116-2.223-12.271-4.605-14.322-1.139-.99-2.597-1.698-4.428-2.14-6.224-1.485-12.304-5.965-12.375-6.035-6.58 3.753-13.63 3.283-20.21-.007-8.461 5.64-7.297 5.018-11.59 6.042-1.83.442-3.289 1.15-4.427 2.14-2.383 2.05-5.103 6.206-4.605 14.322a6.514 6.514 0 0 0 3.503 5.41Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M37.681 51.437c-.071.07-5.364 4.55-11.588 6.035-1.832.442-3.29 1.15-4.428 2.14-2.383 2.05-5.103 6.206-4.605 14.322.142 2.299 1.638 4.625 3.7 5.704 5.993 3.147 16.148 6.355 27.262 6.355 11.113 0 21.738-3.208 27.731-6.355 2.063-1.079 3.405-3.406 3.547-5.704.498-8.116-2.223-12.271-4.605-14.322-1.139-.99-2.597-1.698-4.428-2.14-6.224-1.485-12.304-5.965-12.375-6.035"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M52.7 79.692c5.834 0 12.318-1.254 18.8-5.64"
  }));
};
export default SvgProfile;